

export const veoFAQ = {
    title: '常见问题',
    subtitle: '了解视频生成、关键帧、多参考图与原生音频功能。',
    items: [
      { num: '01', q: '什么是 AI 视频生成？有哪些新功能？', a: '支持关键帧、多参考图、原生音频、延长时长、角色一致性等功能。' },
      { num: '02', q: '关键帧如何运作？', a: '上传起始/结尾帧，系统生成平滑过渡，精准掌控视频开头与结尾。' },
      { num: '03', q: '多参考图是什么？', a: '以多图引导角色、光照与色调，保持全片一致的视觉风格。' },
      { num: '04', q: '是否支持原生音频？', a: '是。自动生成对白、环境音与动作同步音效，与画面一致。' },
      { num: '05', q: '角色一致性如何做到？', a: '提供角色参考图，系统在多场景保持角色外观与身份一致。' },
      { num: '06', q: 'AI 视频生成有何不同？', a: '关键帧、多图、延时、原生音频、角色一致、真实运动、1080P。' },
      { num: '07', q: '商业使用？', a: '可以。输出可用于商业项目，音频与画质达到专业标准。' },
      { num: '08', q: '费用如何计算？', a: '采用积分制，HD 升级可选；高级功能包含于生成成本。' },
      { num: '09', q: '有哪些创作控制？', a: '关键帧、参考图、角色一致、延时、音频、运动控制，达到电影级精度。' },
      { num: '10', q: '新手适合吗？', a: '适合。界面直观，上传图片或输入文字即可开始。' },
      { num: '11', q: '生成长度？', a: '起始 8 秒；使用延长功能可创作更长视频并保持质量。' },
      { num: '12', q: '质量提升建议？', a: '详述提示、使用关键帧、多图、角色一致、质量模式、升级 1080P。' },
      { num: '13', q: '为何失败？', a: '多为内容政策或输入不符。请遵循指引并确保图片规格正确。' },
      { num: '14', q: '如何制作长片？', a: '使用延长功能或以一致的多段剪辑拼接，达到流畅长内容。' }
    ],
    more: '还有关于视频生成的问题？',
    contact: '联系支持团队 →'
  };
